export const TBANK_TARIFF = 'TBANK.256GB.199RUB.MONTHLY';

export const TBANK_TARIFF_512 = 'TBANK.512GB.TRIAL.MONTHLY';

export const TBANK_PROMO_ID = 't-bank-modal';
